import React, { useState, useEffect } from "react";
import Answer from "../answer/Answer";
import { motion, useAnimation, AnimatePresence } from "framer-motion";

const Question = ({ data, next }) => {
  const { title } = data;

  return (
    <div>
      <AnimatePresence>
        <motion.div
          key={data.title}
          initial={{ opacity: 0, x: 400 }}
          animate={{
            opacity: 1,
            x: 0,
            transition: { delay: 0.5, duration: 0.5 },
          }}
          exit={{ opacity: 0, x: -400 }}
          className={"py-8"}
        >
          <h2 className={"uppercase font-headline text-3xl text-white"}>
            {title}
          </h2>

          <div>
            {data.answers.map((answer, i) => {
              return (
                <Answer
                  data={answer}
                  onClick={next}
                  onClick={() => {
                    next(i);
                  }}
                />
              );
            })}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Question;
